/**
 * Payment status labels, kept together rather than spread through the three
 * language files.
 *
 * `Payment.STATUS_CHOICES` on the backend is succeeded/pending/failed/refunded;
 * `formatPaymentStatus` maps those onto the keys below. They were written in
 * capitals in every language while organisation statuses were title case, so
 * one super admin table shouted PAID while the other said Active. Holding the
 * three wordings side by side makes that kind of drift visible.
 */
export const PAYMENT_STATUS_KEYS = [
  'PAID',
  'PENDING',
  'FAILED',
  'REFUNDED',
] as const

export type PaymentStatusKey = (typeof PAYMENT_STATUS_KEYS)[number]

// A language that misses a status is a compile error rather than a key name
// rendered into the table.
type PaymentStatusLabels = Record<PaymentStatusKey, string>

export const paymentStatusesEn: PaymentStatusLabels = {
  PAID: 'Paid',
  PENDING: 'Pending',
  FAILED: 'Failed',
  REFUNDED: 'Refunded',
}

export const paymentStatusesEl: PaymentStatusLabels = {
  PAID: 'Πληρωμένο',
  PENDING: 'Σε εκκρεμότητα',
  FAILED: 'Αποτυχία',
  REFUNDED: 'Επιστράφηκε',
}

export const paymentStatusesTr: PaymentStatusLabels = {
  PAID: 'Ücretli',
  PENDING: 'Beklemede',
  FAILED: 'Başarısız',
  REFUNDED: 'İade edildi',
}
